'use strict';

export const defaultState = () => ({});

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    show(ctx, slug) {
        return this.$axios.$get(`/products/${slug}`);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
